module.exports = __webpack_public_path__ + "img/arrow-ios-forward.986a7407.svg";